/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import { withDebugMetadata } from '@/utils/withDebugMetadata';
import { withLabradorInstanceof } from '@/utils/withInstanceofProp';
import { LabradorFallback as ResolvedLabradorFallback } from 'base/components/labrador/Fallback';

export const LabradorFallback: typeof ResolvedLabradorFallback = withLabradorInstanceof((props) => {
    return <ResolvedLabradorFallback {...props} {...withDebugMetadata({type: props.type, meta: props.meta})} />;
});

export type LabradorFallbackProps = PropsFromComponent<typeof LabradorFallback>;
